import styles from '../../css/TextSearch.module.css';
import theme from '../../css/appTheme.js';

import {
  Autocomplete,
  Box,
  Stack,
  TextField,
  Button,
  Typography,
  Tooltip,
  Collapse,
} from "@mui/material";
import React, { useEffect, useState, useRef, memo, useCallback } from 'react';
import {useDispatch, useSelector} from "react-redux";
//import BookIcon from "@mui/icons-material/BookOutlined";

import {StarRate as StarRateIcon, Book as BookIcon} from '@mui/icons-material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { getCount, getJobHours } from "../../serverREST";
import { deleteJob, pushJob } from "../../redux/jobsSlice";
import { TextSearchTags } from './TextSearchTags.js';
import {fixLayout} from "../../utils/keyboardLayout";
import {useTranslation} from "react-i18next";

const CustomJobTooltip = 'Это работа из списка Ваших записей. Если Вы хотите удалить данную работу, перейдите в раздел "Собственные нормативы", расположенный ниже.';

function getJobHeader(job) {
    return job.detail.part_name + ' ' + (job.other ? '(' + job.other + ')' : '');
}

function getJobLabel(job) {
    return job.detail.part_name + ' ' +
        (job.other ? '(' + job.other + ')' : '') + ' ' +
        job.operation.operation_name;
}

export default function TextSearch() {
    const [hasChanges, setHasChanges] = useState(false);
    const [openValueMenu, setOpenValueMenu] = useState(false);
    const {i18n, t} = useTranslation();
    const currentLang = i18n.language.split('-')[0];

    const sdhHourPrice = useSelector(state => state.settings.sdhHourPrice)
    const items = useSelector(state => state.lists.textSearchItems); 
    const jobs = useSelector(state => state.jobs.jobs);
    
    const dispatch = useDispatch()

    let filteredOptions;

    // Добавляем одно ложное значение, чтобы был вызов renderTags
    // values используем как значение autocomplete
    // filteredJobs используем для отрисовки тегов в renderTags
    const values = [{ job_id: -1 }];
    const filteredJobs = [{ job_id: -1 }];
    const filteredIds = new Set();
    jobs.forEach((job) => {
        if (job.job_id) {
            filteredJobs.push(job);
            filteredIds.add(job.job_id);
        }
    });

    if (hasChanges) {
        setHasChanges(false);
    }

    const toggleValueMenu = () => {
        setOpenValueMenu(prevValue => !prevValue);
    };

    function onJobClick(job) {
        addValue(job);
        toggleValueMenu();
    };

    function checkEquality(option, value) {
        return option.group === -1 && value.job_id === -1;
    }

    function customSearch(options, state) {
        let words = state.inputValue.toLowerCase().split(' ');
        let valChange = fixLayout(state.inputValue.trim(), currentLang);
        if(state.inputValue !== valChange){
            words = valChange.toLowerCase().split(' ');
        }
        words.forEach((word, index) => {
            if (word === '')
                words.splice(index, 1)
        })

        filteredOptions = options.filter((option) => {
            if (!option.jobs)
                return false;

            const part_name = option.jobs[0].detail.part_name.toLowerCase();
            let needDraw = true;
            words.forEach((word) => {
                if (!part_name.includes(word))
                    needDraw = false
            })
            if (needDraw) {
                let filteredCount = 0;

                option.jobs.forEach((job) => {
                    if (filteredIds.has(job.job_id)) {
                        filteredCount++;
                    }
                });
                needDraw = filteredCount != option.jobs.length;
            }
            return needDraw;
        })
        return filteredOptions;
    }

    function addValue(newJob) {
        if (!jobs.find(job => newJob.job_id === job.job_id)) {
            getJobHours(newJob.job_id, (resp) => {
                dispatch(pushJob({ ...newJob, hourPrice: sdhHourPrice, sdh_hour: resp.data[0].sdh_hour }));
                getCount();
            });
        }
    }

    function removeValue(index) {
        const removedJob = filteredJobs[index];
      
        jobs.forEach((job, jobIndex) => {
            if (job.job_id && job.job_id === removedJob.job_id) {
                dispatch(deleteJob(jobIndex));
            }
        })

        setOpenValueMenu(false);
    }

    return (
        <Box>
            <AutocompleteWrap
                open={openValueMenu}
                value={values}
                options={items}
                multiple
                filterSelectedOptions
                disableClearable

                size='small'
                popupIcon={null}
                sx={{
                    m: 0, backgroundColor: '#fff', p: 1,
                    '& input': { width: '100% !important', },
                    '& .MuiAutocomplete-inputRoot': { paddingRight: '0 !important' },
                }}
                ListboxProps={{ style: { maxHeight: '70vh' } }}
                ChipProps={{ color: 'primary', variant: 'outlined' }}
                noOptionsText={'Ничего не найдено'}
                getOptionLabel={(option) => option.jobs ? getJobHeader(option.jobs[0]) : '--'}
                filterOptions={customSearch}
                isOptionEqualToValue={checkEquality}
                onOpen={() => { console.log('open'); toggleValueMenu(); }}
                onClose={() => toggleValueMenu()}
                renderTags={(v, getTagProps) => (
                    <TextSearchTags
                        startIndex={1}
                        limitTags={1}
                        values={filteredJobs}
                        getValueLabel={(value) => getJobLabel(value)}
                        getTagProps={args => ({
                            ...getTagProps(0),
                            onDelete: event => removeValue(args.index),
                        })}
                        onOpen={() => setOpenValueMenu(false)}
                        onClose={() => setHasChanges(true)}
                    />
                )}
                onJobClick={onJobClick}
                filteredIds={filteredIds}
                getFilteredOptions={() => filteredOptions}
            >
            </AutocompleteWrap>
        </Box>
    )
}

function AutocompleteWrap(params) {
    const { onJobClick, onOpen, filteredIds, getFilteredOptions, ListboxProps, ...restParams } = params;

    const [focusIndex, setFocusIndex] = useState(-1);
    const [focusSubIndex, setSubFocusIndex] = useState(-1);
    const [openedGroup, setOpenedGroup] = useState(0);
    const [inputValue, setInputValue] = useState('');
    const [isJobSelected, setIsJobSelected] = useState(false);

    const [lastScrollBottom, setLastScrollBottom] = useState(0);
    const [focusReason, setFocusReason] = useState('');

    const focusedItemRef = useRef(null);
    const containerRef = useRef(null);

    let scroll = 0;
    if (containerRef.current && lastScrollBottom !== 0 && focusReason === 'arrows') {
        const container = containerRef.current;

        container.scrollTop = lastScrollBottom - container.clientHeight;
        scroll = container.scrollTop;
    }

    useEffect(() => {
        const container = containerRef.current;
        const element = focusedItemRef.current;

        if (container && element) {
            const scrollBottom = container.clientHeight + container.scrollTop;
            const hasScroll = container.scrollHeight > container.clientHeight;

            let et = element.offsetTop;
            let eb = et + element.offsetHeight;
            let sb = lastScrollBottom !== 0 ? lastScrollBottom : scrollBottom;
            let sh = container.clientHeight;
            let st = sb - sh;

            if (hasScroll && focusReason === 'arrows') {
                if (eb > sb) {
                    sb = eb;
                    st = sb - sh;
                    container.scrollTop = st;
                } else if (et < st) {
                    st = et;
                    sb = st + sh;
                    container.scrollTop = st;
                }
                if (lastScrollBottom !== sb) {
                    setLastScrollBottom(sb);
                }
            }
        }
    }, [focusedItemRef.current, focusIndex, focusSubIndex, openedGroup]);

    const onJobSelected = useCallback((job, index) => {
        setIsJobSelected(true);
        onJobClick(job);
    }, [onJobClick]);

    const openHeader = (group, index, reason) => {
        setOpenedGroup(group);
        setFocus(index, -1, reason);
    };

    const closeHeader = (index, reason) => {
        setOpenedGroup(0);
        setFocus(index, -1, reason);
    };

    const onHeaderClick = useCallback((isOpened, group, index) => {
        if (isOpened)
            closeHeader(index, 'mouse');
        else
            openHeader(group, index, 'mouse');
    }, []);

    const find = (arr, startIndex, direction, predicate) => {
        if (direction === 1) {
            for (let i = startIndex; i < arr.length; i++) {
                if (predicate(arr[i]))
                    return i;
            }
        } else if (direction === -1) {
            for (let i = startIndex; i >= 0; i--) {
                if (predicate(arr[i]))
                    return i;
            }
        }
        return -1;
    };

    const onKeyDown = (event, value) => {
        if (!value && event.key === 'Backspace') {
            event.stopPropagation();
        }
        switch (event.key) {
            case 'ArrowUp':
                moveFocus(-1);
                event.stopPropagation();
                break;
            case 'ArrowDown':
                moveFocus(1);
                event.stopPropagation();
                break;
            case 'Enter':
                selectOnFocus();
                event.stopPropagation();
                break;
            
            default:
                break;
        }
    };

    const moveFocus = (offset) => {
        if (!params.open) {
            return;
        }
        const options = getFilteredOptions();
        const option = focusIndex >= 0 ? options[focusIndex] : null;
        const isSubGroup = option && option.group === openedGroup;

        let newIndex = focusIndex;
        let newSubIndex = focusSubIndex;

        if (isSubGroup) {
            newSubIndex = find(
                option.jobs,
                focusSubIndex + offset,
                offset,
                job => !filteredIds.has(job.job_id)
            );
            if (newSubIndex < 0) {
                closeHeader(focusIndex, 'arrows');
                newSubIndex = -1;
            }
        } else {
            if (focusIndex < 0) {
                newIndex = offset > 0 ? 0 : options.length - 1;
            } else {
                newIndex = (focusIndex + offset + options.length) % options.length;
            }
        }
        if (newIndex !== focusIndex || newSubIndex !== focusSubIndex) {
            setFocus(newIndex, newSubIndex, 'arrows');
        }
        // console.log('moveFocus', 'x', newIndex, 'y', newSubIndex);
    };

    const selectOnFocus = () => {
        const options = getFilteredOptions();
        if (!options) {
            return;
        }
        if (focusIndex >= 0 && focusIndex < options.length) {
            const option = options[focusIndex];
            const isOpened = option.group === openedGroup;

            if (isOpened && focusSubIndex >= 0 && focusSubIndex < option.jobs.length) {
                const lastIndex = find(
                    option.jobs,
                    option.jobs.length - 1,
                    -1,
                    job => !filteredIds.has(job.job_id)
                );

                onJobSelected(option.jobs[focusSubIndex]);
                moveFocus(focusSubIndex === lastIndex ? -1 : 1);
            } else if (isOpened) {
                closeHeader(focusIndex, 'arrows');
            } else {
                openHeader(option.group, focusIndex, 'arrows');
            }
        }
    };

    const setFocus = (index, subIndex, reason) => {
        setFocusIndex(index);
        setSubFocusIndex(subIndex);
        setFocusReason(reason);
    };

    const onInputChange = (event, newValue) => {
        if (!isJobSelected || newValue !== '' || !params.open) {
            setInputValue(newValue);
            setOpenedGroup(0);
            setFocus(-1, -1, 'input');
        }
        if (isJobSelected) {
            setIsJobSelected(false);
        }
    };

    const onOptionFocusLeave = useCallback((index) => {
        setFocus(-1, -1, 'mouse');
    }, []);

    return (
        <Autocomplete
            {...restParams}
            ListboxProps={{
                ...ListboxProps,
                ref: containerRef,
                onScroll: (e) => {
                    const scrollBottom = e.target.scrollTop + e.target.clientHeight;
                    if (lastScrollBottom != scrollBottom) {
                        setLastScrollBottom(scrollBottom);
                    }
                }
            }}
            onOpen={() => {
                setOpenedGroup(0);
                setFocus(-1, -1, 'open');
                params.onOpen();
            }}
            inputValue={inputValue}
            onInputChange={onInputChange}
            renderInput={(props) => (
                <TextField
                    {...props}
                    label="Поиск"
                    variant='standard'
                    onKeyDown={event => onKeyDown(event, props.inputProps.value)}
                />
            )}
            renderOption={(props, option, state) => {
                const index = props['data-option-index']; // state.index есть не всегда
                const isFocused = focusIndex === index;
                const isOpened = openedGroup === option.group;
                //console.log(props)
                return (
                    <div
                        {...(isFocused ? { ref: focusedItemRef } : {})}
                        key={props.id}
                    >
                        <MemoizedOption
                            index={index}
                            group={option.group}
                            option={option}
                            isOpened={isOpened}
                            isFocused={isFocused}
                            isLight={isFocused ? focusReason === 'mouse' : false}
                            onHeaderClick={onHeaderClick}
                            onJobClick={onJobSelected}
                            filteredIds={filteredIds}
                            focusIndex={isOpened ? focusSubIndex : -1}
                            onFocusLeave={onOptionFocusLeave}
                        />
                    </div>
                );
            }}
        />
    );
}

const MemoizedOption = memo(Option);
function Option({
    index,
    option,
    isOpened,
    isFocused,
    isLight,
    onHeaderClick,
    onJobClick,
    filteredIds,
    focusIndex,
    onFocusLeave
}) {
    // console.log('Option');

    let headerClass = styles.optionHeader;
    if (isFocused && focusIndex < 0) {
        headerClass = isLight ? styles.optionHeaderInFocusLight : styles.optionHeaderInFocus;
    }
    return (
        <Box
            className={headerClass}
            sx={{ pt: '6px', pb: '6px', pl: '16px', pr: '16px' }}
            onMouseLeave={() => (onFocusLeave && isFocused) && onFocusLeave(index)}
        >
            <Stack
                direction={'row'}
                justifyContent={'space-between'}
                color={'primary'}
                alignItems={'center'}
                onClick={() => {
                    onHeaderClick && onHeaderClick(isOpened, option.group, index);
                }}
            >
                <Typography>{getJobHeader(option.jobs[0])}</Typography>
                {isOpened
                    ? <ExpandLessIcon sx={{ width: '30px' }} />
                    : <ExpandMoreIcon sx={{ width: '30px' }} />
                }
            </Stack>
            <Collapse in={isOpened} unmountOnExit>
                <Stack direction="row" flexWrap="wrap" >
                    {option.jobs.map((job, jobIndex) => {
                        if (filteredIds.has(job.job_id)) {
                            return (<React.Fragment key={job.job_id} />);
                        }
                        const isFocused = jobIndex === focusIndex;
                        return (
                            <Button
                                key={job.job_id}
                                variant='outlined'
                                size='small'
                                sx={{ m: '2px', flexGrow: 1,
                                    ...(isFocused ? { backgroundColor: '#97979733' } : {}),
                                    '&:hover': {
                                        backgroundColor: theme.palette.primary.main + '20',
                                    },
                                }}
                                onClick={() => onJobClick(job, index)}
                            >
                                {job.custom
                                    ?   <Tooltip
                                        sx={{
                                            width: '18px',
                                            height: '18px',
                                            color: theme.palette.secondary.main,
                                        }}
                                        title={job.owned ? `Собственный норматив` : `Дружественный норматив`}
                                    >{job.owned ? <StarRateIcon fontSize="small" color="secondary"/>
                                        :   <Box style={{
                                            "padding": "0px 2px",
                                            "backgroundColor": `#${job.user_code}`,
                                            "color": "white",
                                            "alignItems": "center",
                                            "display": "flex",
                                            "borderRadius": "2px"
                                        }}>
                                            <Typography variant='body2' fontSize={13}>
                                                {job.user_num}
                                            </Typography>
                                        </Box>}
                                    </Tooltip>
                                    :
                                    <></>
                                   
                                }
                                <Typography variant='body2' fontSize={13} >
                                    
                                    {job.operation.operation_name}
                                 
                                    </Typography>
                            </Button>
                        )
                    })}
                </Stack>
            </Collapse>
        </Box>
    )
}